module.exports = __webpack_public_path__ + "media/src/images/icons/footer/footer-agreement-7426b4a30fe0d07a508a2292f73cef77.svg";